import { prioritizedBlogPostTagList } from './prioritized-blog-post-tag-list'
import * as stripperAndCategorizer from './blog-post-stripper-and-categorizer'
import utils from '../utils'


export const getUrlForBlogPost = (post, languge) => {
  const lang = languge ? languge.slice(0, 2) : 'en';
  const postInCurrentLang = post?.languages.find((postLang) => postLang.languageCode === lang);
  const podcastCategory = prioritizedBlogPostTagList.find(obj => obj.value === 'podcast')
  if (postInCurrentLang) {
    if (post.categories.includes(podcastCategory.id)) {
      return '/content/podcast/' + postInCurrentLang.slug
    }
    return `${languge}/content/` + postInCurrentLang.slug
  }
  if (post.categories.includes(podcastCategory.id)) {
    return '/content/podcast/' + post.slug
  }
  return 'en-gb/content/' + post.slug
}

export const getShortTextForCard = (story, numberOfCharacters) => {
  let text = story.excerpt.rendered
  text = utils.decodeHtml(text)
  text = stripperAndCategorizer.removePTags(text)
  text = stripperAndCategorizer.getTextPreview(text, numberOfCharacters)
  return text
}

const getMonth = {
  '01': 'January',
  '02': 'February',
  '03': 'Mars',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December'
}

export function insertBlogMetaData(post) {
  const date = formatDate(post.date)
  // const timeToRead = getReadTime(post)
  // const metaData = date + ' - ' + timeToRead + ' min read'
  return date
}

function formatDate (date) {
  const timeType = date.split('-')
  const formattedDate = getMonth[timeType[1]] + ' ' + timeType[2][0] + timeType[2][1] + ', ' + timeType[0]
  return formattedDate
}

function getReadTime (post) {
  const htmlWrapper = document.createElement('div')
  htmlWrapper.innerHTML = post.content.rendered
  const amountOfCharsInPost = htmlWrapper.innerText.length
  const avgReadSpeedCharecterPerMinute = 850
  const readTime = Math.floor(amountOfCharsInPost / avgReadSpeedCharecterPerMinute)
  return readTime
}